/** @jsxImportSource @emotion/react */
import React, { useEffect, useState } from 'react'
import { default_theme as theme } from '../../emotion/theme'
import { jsx, css } from '@emotion/react'

export const NoodleHead = ({}) => {
    
    return (
        <div css={stacked_style}>
          <div css={[noodle_common_style, noodle_head_style]}>
            &nbsp;
          </div>
          <NoodleStem />
        </div>
    )

}

export const NoodleStem = ({}) => {
    
    return (
        <div css={[noodle_common_style, noodle_stem_style]}>
          &nbsp;
        </div>
    )

}

export const NoodleTail = ({}) => {
    
    return (
        <div css={stacked_style}>
          <NoodleStem />
          <div css={[noodle_common_style, noodle_tail_style]}>
            &nbsp;
          </div>
        </div>
    )

}

// Draws a vertical stem that bends to the right into the content area.
// If continueDown is true, the vertical stem continues straight down past the bend.
export const NoodleBendRight = ({ continueDown = false, strokeWidth = 8, height = 40, color }) => {
    const stroke = color || theme.colors.light_grey

    return (
        <div css={[stacked_style, noodle_elbow_style]}>

          {/* elbow path */}
          <svg
            viewBox={`0 0 80 44`}
            preserveAspectRatio="none"
            style={{ width: '100%', height }}
          >
            <path d="M3 0.5C2.9999 15.5 4.6 40 31 40C57.4 40 45.6666 40 80 40" stroke={stroke} strokeWidth={strokeWidth} fill="none" />
          </svg>


          {/* Continue the stem below the elbow if requested */}
          {continueDown && (
            <div
              css={[noodle_common_style, noodle_stem_style, noodle_stem_elbow_style]}
              style={{
                // flexGrow: 1,
                // minHeight: 24,
                // alignSelf: 'flex-start',
                // // 31/80 of the elbow's width -> aligns with the elbow's bottom x
                // marginLeft: '0%'
              }}
            >
              &nbsp;
            </div>
          )}
        </div>
    )
}

const noodle_common_style = css`
  border: solid 3px ${theme.colors.light_grey};
  background-color: ${theme.colors.light_grey};
`

const noodle_head_style = css`
  width: 24px;
  height: 24px;
  border-radius: 24px;
`

const noodle_stem_style = css`
  width: 3px;
  height: 100%;
  min-height: 10px;
`

const noodle_tail_style = css`
  width: 24px;
  height: 24px;
`

const noodle_elbow_style = css`
  position: relative;
  height: 40px;
`

const noodle_stem_elbow_style = css`
  position: absolute;
  top: 0;
  left: 0;
  height: 80px;
`

const stacked_style = css`
  display: flex;
  // width: 100%;
  height: 100%;
  justify-content: center;
  flex-direction: column;
  align-items: center;
`
